import { render, staticRenderFns } from "./DownloadAppointmentTimeline.vue?vue&type=template&id=10fd54d6&scoped=true"
import script from "./DownloadAppointmentTimeline.vue?vue&type=script&lang=js"
export * from "./DownloadAppointmentTimeline.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppointmentTimeline.vue?vue&type=style&index=0&id=10fd54d6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd54d6",
  null
  
)

export default component.exports